// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"463":"e7efc994","794":"3a3e55e2","963":"bee97018","981":"1fa27cff"}[chunkId] + ".chunk.css";
};